import React from "react";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import AttendenceTable from "../../PageComponent/Attendence/AttendenceTable/AttendenceTable";

function Attendence() {
  return (
    <ContextApi>
      <div>
        <AttendenceTable />
      </div>
    </ContextApi>
  );
}

export default Attendence;
